export default __webpack_public_path__ + "static/media/logo-white.bdee0dc7.png";